/* A client's clip on a task card — the frame, its poster, the play mark and the length. The film
 * plays in the one player on the client's card (`features/clip-player`). Moved out of `feedbackRow.module.css` with `ClipFrame` on 24 September 2026, when the
 * clip got its natural shape on the new cards (owner: "never a stretched strip").
 *
 * The frame's HEIGHT is the density's and its WIDTH follows from the film's own proportion
 * (`--clip-aspect`, off the queue payload's width and height) — so a landscape clip is 16:9 and a
 * phone held upright stays a narrow portrait, and neither is cropped into a strip. The box exists
 * before the poster is fetched, so nothing moves when the image lands. */

.frame {
  position: relative;
  flex: none;
  height: var(--clip-height);
  aspect-ratio: var(--clip-aspect);
  max-width: 100%;
  overflow: hidden;
  background: var(--bg-sunken);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-md);
}

.desk { --clip-height: 272px; }

/* The Przegląd's card: as tall as the card's body, whatever the kind's head leaves it. */
.quick { --clip-height: 100%; }

/* The Pulpit's card: a small poster in the body (owner, 26 September 2026) — a phone's portrait at
 * 112 tall (63 wide), a landscape film no wider than 150, so the words beside it keep their room. */
.short {
  --clip-height: min(112px, calc(150px / var(--clip-aspect)));
}

/* `shared/ui/photoBox.module.css` declares the fit and the ground; this declares the box. */
.poster {
  position: absolute;
  inset: var(--space-0);
  width: 100%;
  height: 100%;
}

/* The play mark on every frame, over the poster and over a frame with none — see the old
 * `feedbackRow` note: one wash disc, theme-independent because it stands on a photograph. */
.playMark {
  position: absolute;
  inset-block-start: 50%;
  inset-inline-start: 50%;
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  color: var(--text-on-photo);
  background: var(--wash-on-photo-strong);
  border-radius: var(--r-pill);
  transform: translate(-50%, -50%);
}

.playMarkGlyph {
  width: 17px;
  height: 17px;
  margin-inline-start: var(--space-2px);
}

/* The frame is a second, redundant target for the card's own primary: no tab stop. */
.target {
  cursor: pointer;
}

.duration {
  position: absolute;
  right: var(--space-6px);
  bottom: var(--space-6px);
  display: inline-flex;
  align-items: center;
  height: 17px;
  padding: var(--space-0) var(--space-6px);
  font-size: var(--fs-label-sm);
  font-weight: var(--fw-extrabold);
  color: var(--text-on-photo);
  background: var(--wash-on-photo-strong);
  border-radius: var(--radius-5px);
  font-variant-numeric: tabular-nums;
}

